export default "__VITE_PUBLIC_ASSET__56e17572__"